import { PaymentMethodEnum as t } from "@systemeio/ui";
import { StripePaymentMethodUsingPaymentElementEnum as e } from "../enum/stripe-payment-method-using-payment-element-enum.mjs";
const r = {
  [e.Card]: t.stripe_card,
  [e.Ideal]: t.stripe_ideal,
  [e.Klarna]: t.stripe_klarna,
  [e.Bancontact]: t.stripe_bancontact
}, i = (n) => !!Object.values(r).find((a) => a === n);
export {
  i as isStripePaymentMethodUsingPaymentElement
};
